<template>
  <Transition>
    <div class="fondo_transparente" >
      <div class="ventana_modal" id="dragg-cont" ref="draggCont">
        <XCerrarModal sizeX="P" @click="cerrarModal" id="XCerrar"/>
        <div class="header" id="dragg-header" @mousedown="dragMouseDown">
          <p>Validar e-mail</p>
        </div>
        <div class="body">
          <input
            type="text"
            v-model="pin"
            name="pin"
            ref="pin"
            class="entrada"
            placeholder="PIN de validación"
          >
        </div>
        <div class="enviar" @click="enviar">ENVIAR</div>
      </div>
    </div>
  </Transition>
 </template>

<script>
import XCerrarModal from './XCerrarModal.vue'
export default {
  components: { XCerrarModal },
  name: 'modalPIN',
  props: {
  },
  data () {
    return {
      pin: '',
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0
      }
    }
  },
  methods: {
    cerrarModal: function () {
      this.pin = ''
      this.$emit('cerrar')
    },
    enviar () {
      if (this.pin.length !== 6 || isNaN(parseFloat(this.pin))) {
        this.alertJoa('El PIN debe tener 6 dígitos numéricos', 'W')
      } else {
        this.$emit('recibirPIN', this.pin)
        this.pin = ''
        this.cerrarModal()
      }
    },
    dragMouseDown: function (event) {
      event.preventDefault()
      // get the mouse cursor position at startup:
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      document.onmousemove = this.elementDrag
      document.onmouseup = this.closeDragElement
    },
    elementDrag: function (event) {
      event.preventDefault()
      this.positions.movementX = this.positions.clientX - event.clientX
      this.positions.movementY = this.positions.clientY - event.clientY
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      // set the element's new position:
      this.$refs.draggCont.style.top = (this.$refs.draggCont.offsetTop - this.positions.movementY) + 'px'
      this.$refs.draggCont.style.left = (this.$refs.draggCont.offsetLeft - this.positions.movementX) + 'px'
    },
    closeDragElement () {
      document.onmouseup = null
      document.onmousemove = null
    }
  },
  computed: {
  }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
}
.ventana_modal{
    font-family: OpenL;
    background-color: var(--azul2);
    width: 300px;
    min-height: 100px;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    border-radius: 5px;
    display: grid;
    z-index: 100;
    box-shadow: rgb(108, 108, 108) 5px 5px 7px;

}
.header{
  background-color: var(--azul2);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  width: 100%;
  display: flex;
}
.header p{
  text-align: left;
  margin-left: 20px;
  margin-bottom: 5px;
  align-self: center;
  color: var(--na);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 22px;
  font-weight: lighter;
}
.body{
  background-color: var(--azul2);
  display:flex;
  color:rgb(20, 76, 109);
  justify-content: center;
  border:none;
}
.entrada{
  padding-left: 8px;
  border:none;
}
.entrada:focus{
 outline-color: transparent;
}
.enviar {
   color: var(--na);
   cursor: pointer;
   margin-top: 5px;
   transition: all 0.5s ease-out;
}
.enviar:hover {
  transform: translateX(4px);
}
.v-enter-active, .v-leave-active {
  transition: opacity 0.4s ease, transform 0.4s;
}
.v-enter-from, .v-leave-to {
  opacity: 0;
  transform: translateY(-25px);
}
#dragg-cont {
  position: absolute;
  z-index: 9;
}
#dragg-header {
  cursor: move;
  z-index: 10;
}
#XCerrar{
  z-index: 11;
}
@media screen and (max-width: 575px){
  .ventana_modal{
    width: 90%;
  }

}
</style>
